import { api } from '../lib/api';
import { useFetch } from '../lib/useFetch';
import { fmtMoney } from '../lib/format';
import type { PageProps } from '../App';

interface ResumoGeral { disponibilidades: Array<{ apelido: string; saldo: number }> }

export function ContasBancarias(_: PageProps) {
  const data = useFetch(async () => {
    const [contas, resumo] = await Promise.all([
      api.listContasBancarias(),
      api.relatorio<ResumoGeral>('resumo-geral').catch(() => ({ disponibilidades: [] } as ResumoGeral)),
    ]);
    const saldos = new Map(resumo.disponibilidades.map((d) => [d.apelido, d.saldo]));
    return contas.items.map((c) => ({ ...c, saldoReal: saldos.get(c.apelido) ?? c.saldo ?? c.saldo_inicial ?? 0 }));
  }, []);

  return (
    <div className="page narrow">
      <h1 style={{ marginBottom: 20 }}>Contas Bancárias</h1>
      {data.loading ? (
        <div className="loading">Carregando…</div>
      ) : (data.data?.length ?? 0) === 0 ? (
        <div className="empty">Nenhuma conta bancária cadastrada.</div>
      ) : (
        <div className="grid-2">
          {data.data!.map((c) => (
            <div className="card pad" key={c.id}>
              <div className="card-title" style={{ marginBottom: 3 }}>{c.apelido}</div>
              <div className="text-sm muted" style={{ marginBottom: 14 }}>
                {[c.banco, c.agencia && `Ag. ${c.agencia}`, c.conta && `C/C ${c.conta}`].filter(Boolean).join(' · ') || '—'}
              </div>
              <div className="k-label">Disponível</div>
              <div className="mono" style={{ fontSize: 24, fontWeight: 600, color: 'var(--primary)' }}>{fmtMoney(c.saldoReal)}</div>
              {c.titular && <div className="text-sm muted" style={{ marginTop: 4 }}>Titular: {c.titular}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
